import { LinearLoader } from 'components/ui/LinearLoader/LinearLoader';
import { Play } from 'models/tagging/Play';
import React from 'react';
import { Batter, Loader, PlaceholderPlayWrapper, Text } from './PlaceholderPlayStyles';

interface IProps {
  batter: string;
  isHidden: boolean;
  play: Play;
  onClick: (play: Play) => void;
  isSelected: boolean;
}

export const PlaceholderPlay: React.FC<IProps> = ({ batter, isHidden, onClick, play, isSelected }) => {
  return (
    <PlaceholderPlayWrapper
      className={`${isHidden ? ' hidden' : ''}${isSelected ? ' selected' : ''}`}
      onClick={() => onClick(play)}
      data-testid='placeholder-play'
    >
      <Batter>{batter}</Batter>
      <Text>Waiting for pitch...</Text>
      <Loader>
        <LinearLoader />
      </Loader>
    </PlaceholderPlayWrapper>
  );
};
